import { types as t, getParent } from 'mobx-state-tree';
import PropertyItem from './PropertyItem';

const SizeInformation = t.model("SizeInformation", {
    Sku: t.string,
    VariantSku: t.maybeNull(t.string),
    Guid: t.string,
    ProductDefinition: t.maybeNull(t.string),
    ProductId: t.string,
    DisplayName: t.maybeNull(t.string),
    ShortDescription: t.maybeNull(t.string),
    LongDescription: t.maybeNull(t.string),
    Name: t.string,
    Variants: t.maybeNull(t.optional(t.array(t.late(() => SizeInformation)), [])),
    Properties: t.optional(PropertyItem, {})
}).views(self => ({


    get ParentProduct() {
        return getParent(self, 2);
    },
    get HasVariants() {
        return self.Variants && self.Variants.length > 0;
    },
    PropertyByKey(key) {
        const p = self.Properties[key];
        if (p) {
            return p;
        } else {
            return null;
        }
    },
    FilteredVariants(filter) {
        // filter: [{GroupKey:"ColorId",GroupValue:"099"},{GroupKey:"Size",GroupValue:"4XL"}]
        return {

            Variants: self.Variants.filter(v => filter.every(f => {
                return !v.Properties[f.GroupKey] || v.Properties[f.GroupKey] === f.GroupValue;
            })),
            Images: self.ProductMedia ? self.ProductMedia.filter(v => filter.every(f => {
                return !v.Properties[f.GroupKey] || v.Properties[f.GroupKey] === f.GroupValue;
            })) : null
        }
    }
})).actions(self => ({
}));
export default SizeInformation;